// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationListRequestModel from '../../model/get-organisation-list-request-model';
import GetOrganisationListRequestDTO from '../dto/get-organisation-list-request-dto';
import dtoSchema from '../schemas/get-organisation-list-request-schema';

export default abstract class GetOrganisationListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationListRequestDTO>) {
    super();
    if (data) {
      this.organisationName = data.organisationName;
      this.region = data.region;
    }
  }
  /**
  */
  organisationName?: string;
  /**
  */
  region?: string;

  static toModel(dto: DeepPartial<GetOrganisationListRequestDTO>): GetOrganisationListRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationListRequestDTO> | undefined | null): GetOrganisationListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationListRequestDTO> | undefined | null): GetOrganisationListRequestModel | undefined {
    return dto ? new GetOrganisationListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationListRequestModel> | GetOrganisationListRequestModel): GetOrganisationListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      organisationName: unwrapped.organisationName,
      region: unwrapped.region,
    } as GetOrganisationListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationListRequestModel, can not map to GetOrganisationListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
